import { useEffect, useState } from 'react';

const useMedalMultiSelect = () => {
  const [options] = useState([{id: 1, name: 'Gold'}, {id: 2, name: 'Silver'}, {id: 3, name: 'Bronze'}]);

  return {
    options
  };
};

export default useMedalMultiSelect;